import { Outlet } from "react-router-dom";
import { useUserContext } from "../hooks/UserContext";
import { useNavigate } from "react-router-dom";
import ResponsiveMenu, { appBarHeight, drawerWidth } from "./components/ResponsiveMenu";
import { Box, Container } from "@mui/material";
import { menuItems } from "../models/MenuItems";
import { useState } from "react";
import { layoutStyles } from "../theme/appTheme";
import { useAppConfig } from "../hooks/AppConfigContext";

const Layout = () => {
    const { getUser } = useUserContext();
    const navigate = useNavigate();
    const { config } = useAppConfig();
    const [menuWidth, setMenuWidth] = useState(drawerWidth);

    const getMenuItems = () => {
        const user = getUser();
        if (!user) return [];
        const permissions = user.permissions ?? [];
        const isClientUser = Boolean(user.idCliente);
        if (isClientUser) {
            return menuItems
                .filter(item => item.label === "Clientes")
                .map(item => ({
                    ...item,
                    subItems: item.subItems?.filter(subItem =>
                        (!subItem.requiresConMesas || config?.conMesas === true) && (subItem.requiredPermission
                            ? permissions.includes(subItem.requiredPermission)
                            : true)
                    )
                }))
                .filter(item => item.subItems?.length);
        }

        return menuItems.map(item => {
            const subItems = item.subItems?.filter(subItem =>
                (!subItem.requiresConMesas || config?.conMesas === true) && (subItem.requiredPermissionsAny
                    ? subItem.requiredPermissionsAny.some(permission => permissions.includes(permission))
                    : subItem.requiredPermission
                        ? permissions.includes(subItem.requiredPermission)
                        : true)
            );

            return {
                ...item,
                subItems
            };
        }).filter(item => {
            // Check if the user has the required permission for the main item
            const hasPermissionForItem = item.requiredPermission
                ? permissions.includes(item.requiredPermission)
                : false;

            // Check if the user has the required permission for any subItem
            const hasPermissionForSubItem = item.subItems?.some(subItem =>
                subItem.requiredPermissionsAny
                    ? subItem.requiredPermissionsAny.some(permission => permissions.includes(permission))
                    : subItem.requiredPermission
                        ? permissions.includes(subItem.requiredPermission)
                        : Boolean(subItem.path)
            );

            return item.label !== "Clientes" && (hasPermissionForItem || hasPermissionForSubItem);
        });
    };

    const handleMenuItemClick = (path: string) => {
        // Navigate to the route directly
        navigate(`/${path}`);
    };

    return (
        <Box sx={layoutStyles.appBackground}>
            <ResponsiveMenu
                Titulo="GROVIA - Software de Gestión"
                MenuItems={getMenuItems()}
                onMenuItemClick={handleMenuItemClick}
                onWidthChange={setMenuWidth}
            />
            <Box
                component="main"
                sx={{
                    pt: `${appBarHeight + 16}px`,
                    ml: { md: `${menuWidth}px` },
                    "--app-menu-width": `${menuWidth}px`,
                    transition: (theme) => theme.transitions.create("margin-left", { duration: theme.transitions.duration.shorter }),
                }}
            >
                <Container maxWidth="xl" sx={layoutStyles.mainContainer}>
                    <Outlet /> {/* This renders the child route component */}
                </Container>
            </Box>
        </Box>
    );
};

export default Layout;
